import { render, staticRenderFns } from "./AuthBlock.vue?vue&type=template&id=0e5caf62&"
import script from "./AuthBlock.vue?vue&type=script&lang=js&"
export * from "./AuthBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports